import { useStore } from "../store";
import { HeaderDetails } from "./HeaderDetails";
import { BroadcastItemTitle } from "./BroadcastItemTitle";

const style = {
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  padding: 14,
  gap: 4,
  height: 46+2 // additional padding because peoples eyes aren't perfect or whatever.. it looks better with this anyways
};

const weekdays = ["일", "월", "화", "수", "목", "금", "토"];

export function BroadcastItem(props) {
  const { broadcast, setBroadcast, broadcasts } = useStore();

  const startDate = new Date(props.broadcast.broadcastStartTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));
  const finishDate = new Date(props.broadcast.broadcastFinishTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));

  // If start date and finish date is different
  const finishesTomorrow = Math.floor(startDate.getTime() / 86400000) !== Math.floor(finishDate.getTime() / 86400000);

  // nth-child polyfill
  const backgroundColorStyle = {
    backgroundColor: props.broadcast.id === broadcast?.id ? "#D0D0D0" : (props.index % 2 === 0 ? "#F8F8F8" : "#F0F0F0")
  };

  function onBroadcastClick(broadcastId) {
    const selectedBroadcast = broadcasts.find(b => b.id === broadcastId);
    setBroadcast(selectedBroadcast);
  }

  return (<>
    <li style={ { ...style, ...backgroundColorStyle } } onClick={ () => onBroadcastClick(props.broadcast.id) }>
      <BroadcastItemTitle text={ props.broadcast.deleted ? <s>{ props.broadcast.episode }</s> : props.broadcast.episode }/>
      <HeaderDetails text={
        [
          `${startDate.getUTCMonth()+1}/${startDate.getUTCDate()}`,
          `(${ weekdays[startDate.getUTCDay()] })`,
          `${startDate.getUTCHours().toString().padStart(2, "0")}:${startDate.getUTCMinutes().toString().padStart(2, "0")}`,
          "-",
          finishesTomorrow && `${finishDate.getUTCMonth()+1}/${finishDate.getUTCDate()} (${weekdays[finishDate.getUTCDay()]})`,
          `${finishDate.getUTCHours().toString().padStart(2, "0")}:${finishDate.getUTCMinutes().toString().padStart(2, "0")}`,
          props.broadcast.delayTime !== 0 && `(${Math.floor(props.broadcast.delayTime / 600) / 100}분 지연)`
        ].filter(text => text).join(" ")
      }/>
    </li>
  </>);
}
